export const BUDGET_FREQUENCIES = ['one_time', 'monthly', 'quarterly'] as const;
export type BudgetFrequency = typeof BUDGET_FREQUENCIES[number];
export const budgetLabel = (frequency?: string) => frequency === 'monthly' ? 'Monthly budget' : frequency === 'quarterly' ? 'Quarterly budget' : 'One-time budget';
export const budgetSuffix = (frequency?: string) => frequency === 'monthly' ? ' / month' : frequency === 'quarterly' ? ' / quarter' : ' one-time';
